import React from "react";
import EditItemDetails from "../../../Common/Components/EditItemDetails";

const EditDetails = () => {
  return (
    <div>
      <EditItemDetails />
    </div>
  );
};

export default EditDetails;
